// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"540":"ede601e185bfdb920728","586":"72b274776f47ec76e512","845":"3153ea90731f73fda8d0"}[chunkId] + ".css";
};